export const Roles = {
  ADMIN: 'admin',
  USER: 'user',
}

export default {
  Roles
}
